import React from "react";
import classes from './linkBlock.module.css';
import BtnLink from "../button/btnLink";

const NewsItem = (props) => {
    return(
        <>
            <div className={classes.newsItem}>
                <img src={props.newsitem.img} alt="news-banner" />
                <h3>{props.newsitem.title}</h3>
                <p>{props.newsitem.body}</p>
                <BtnLink title={props.newsitem.text} link={props.newsitem.url} />
            </div>
        </>
    )
}

export default NewsItem;